import { GRAY_COLORS } from '../globalTheme';

export const theme = {
	item: {
		padding: '10px',
		background: 'white'
	},
	itemButton: {
		gap: '4px'
	},
	itemHover: {
		background: GRAY_COLORS.gray50
	}
};
